export default __webpack_public_path__ + "static/media/bti-title-en.7b465936.webp";